import { useState } from 'react';

import { InfoIcon, XIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Link from '@/components/atoms/Link/Link';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import useBrains from '@/hooks/useBrains';
import { selectAccountSlug } from '@/redux/session/selectors';

type AiAgentDraftHelpProps = { brainParentId: string };

export const AiAgentDraftHelp = ({ brainParentId }: AiAgentDraftHelpProps) => {
  const { t } = useTranslation();
  const slug = useSelector(selectAccountSlug);
  const { brain } = useBrains(brainParentId);
  const [isDismissed, setIsDismissed] = useState(false);

  if (!brain || isDismissed) {
    return null;
  }

  return (
    <Alert variant="info" className="pr-10 [&>svg]:text-primary">
      <InfoIcon />
      <AlertTitle>{t('rules.ai_agent_help')}</AlertTitle>
      <AlertDescription className="leading-5">
        <Link href={`/${slug}/ai-agents/${brainParentId}`}>
          {brain.name} ({t('common.draft')})
        </Link>{' '}
        {t('rules.ai_agent_help_body')}
      </AlertDescription>
      <Button
        type="button"
        variant="ghost-neutral"
        size="icon-xs"
        className="absolute top-3 right-3"
        aria-label={t('common.close')}
        onClick={() => setIsDismissed(true)}
      >
        <XIcon />
      </Button>
    </Alert>
  );
};
